/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import WebGLRenderGraph from "App/render/webgl/render_graph";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import Batch from "App/render/webgl/renderables/batches/batch";
import Pass from "App/render/webgl/passes/pass";
import IScene from "js_interface/src/scene_interface";

export default
class ParticlesBatch extends Batch {

    public static TypeName: string = "ParticlesBatch";

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aShapeBatchNode: ShapeBatchNode) {
        super(aSceneAPI, aRenderGraph, aShapeBatchNode);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aShapeBatchNode: ShapeBatchNode): ParticlesBatch {
        return new ParticlesBatch(aSceneAPI, aRenderGraph, aShapeBatchNode);
    }

    public update() {
        super.update();
    }

    public render(aRenderPass: Pass) {
        return;
        /*let shader    = aRenderPass.getActiveShaderRenderable();
        let gl        = this._context.ctx3d;

        // coordinates
        gl.bindBuffer(gl.ARRAY_BUFFER, this._buffers.vertexBuf.id);
        gl.vertexAttribPointer(shader.attributeLocations.a_position, 3, gl.FLOAT, 0, 0, 0);

        gl.drawArrays(gl.POINTS, 0, this._verticesCount);*/
    }
}
